import type { SVGProps } from 'react';

export const SvgImgIllustMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 202 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.001 158.818L2 101.082L101.999 43.3485L202 101.084L102.001 158.818Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M2 111.168V101.082L102.001 158.818V168.904L2 111.168Z"
      fill="url(#paint0_linear_4444_2061)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M201.999 101.084V111.168L102 168.904V158.818L201.999 101.084Z"
      fill="url(#paint1_linear_4444_2061)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M85.118 55.8534L80.0092 47.7502C79.6352 47.156 79.1541 46.6705 78.6555 46.3821L63.6448 37.7151C62.8346 37.247 62.1752 37.6238 62.1723 38.5557L62.0737 73.3178C62.0708 74.2497 62.7259 75.3845 63.5361 75.8512L84.2629 87.8169C85.0731 88.285 85.7326 87.9096 85.7355 86.9777L85.8181 58.0405C85.8195 57.3578 85.5644 56.5607 85.118 55.8534Z"
      fill="white"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M78.8483 62.2946L68.7723 56.4769C67.5417 55.767 66.5418 56.3374 66.5381 57.7499L66.5054 69.3271C66.5017 70.7409 67.4956 72.4617 68.7249 73.1716L78.801 78.9893C80.0315 79.6992 81.0314 79.1289 81.0351 77.7163L81.0678 66.1391C81.0715 64.7254 80.0776 63.0046 78.8483 62.2946Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M71.4623 74.412L71.4939 65.6199C71.4975 64.2741 71.4283 64.0071 70.4684 63.3955L66.8569 61.2972"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M71.0849 69.1911L66.8569 66.7385"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M76.038 61.9209L76.0065 70.713C76.0028 72.0588 76.072 72.3258 77.0319 72.9374L80.6434 75.0356"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M76.4141 67.1404L80.642 69.5942"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M125.579 23.4536C126.399 23.9275 127.062 25.0739 127.059 26.0174L126.862 97.9794C126.859 98.9215 126.192 99.3012 125.372 98.8287L94.3172 80.8991C93.4969 80.4252 92.8345 79.2787 92.8374 78.3367L93.0345 6.37469C93.0374 5.43263 93.7041 5.05291 94.523 5.52539L125.578 23.455L125.579 23.4536Z"
      fill="#ABDCE9"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M113.764 23.5332C114.258 23.8187 114.657 24.51 114.655 25.0767C114.654 25.6449 114.253 25.8724 113.758 25.5869L106.303 21.2824C105.81 20.9969 105.41 20.307 105.412 19.7403C105.413 19.1722 105.815 18.9446 106.309 19.2287L113.764 23.5332Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="2.22222"></path>
    <path
      d="M129.574 39.7686L129.619 23.7898C129.622 22.8478 128.96 21.6999 128.139 21.226L95.5744 2.42529C95.1613 2.1876 94.7888 2.16586 94.5178 2.32238L92.7163 3.3688C92.9859 3.21227 93.3598 3.23401 93.7714 3.4717L126.336 22.2738C127.157 22.7478 127.819 23.8942 127.816 24.8377L127.771 40.8165C128.654 41.3267 129.318 42.4745 129.315 43.4166L129.293 51.3372L127.803 52.2024L127.612 100.032C127.612 100.5 127.445 100.829 127.178 100.984L128.98 99.9375C129.247 99.7824 129.412 99.4534 129.413 98.9853L129.602 51.8749L130.661 51.2589C130.928 51.1038 131.093 50.7748 131.094 50.3067L131.118 42.3687C131.121 41.4267 130.458 40.2788 129.574 39.7686Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M127.774 40.8166C128.656 41.3267 129.32 42.4746 129.317 43.4167L129.294 51.3546C129.291 52.2967 128.624 52.6778 127.804 52.2039L127.613 100.033C127.61 100.975 126.943 101.355 126.123 100.882L93.5579 82.0803C92.7376 81.6064 92.0752 80.46 92.0781 79.5179L92.2839 4.3254C92.2868 3.38334 92.9535 3.00217 93.7724 3.4761L126.337 22.2782C127.158 22.7521 127.82 23.8986 127.817 24.8421L127.772 40.8209L127.774 40.8166ZM126.863 97.9795L127.061 26.0175C127.063 25.0754 126.401 23.9276 125.581 23.4536L94.5246 5.524C93.7043 5.05007 93.0376 5.43124 93.0361 6.3733L92.839 78.3353C92.8361 79.2773 93.4985 80.4252 94.3188 80.8991L125.375 98.8288C126.195 99.3027 126.862 98.9215 126.865 97.9795"
      fill="#FF0019"></path>
    <path
      d="M126.863 97.9795L127.061 26.0175C127.063 25.0754 126.401 23.9276 125.581 23.4536L94.5246 5.524C93.7043 5.05007 93.0376 5.43124 93.0361 6.3733L92.839 78.3353C92.8361 79.2773 93.4985 80.4252 94.3188 80.8991L125.375 98.8288C126.195 99.3027 126.862 98.9215 126.865 97.9795M127.774 40.8166C128.656 41.3267 129.32 42.4746 129.317 43.4167L129.294 51.3546C129.291 52.2967 128.624 52.6778 127.804 52.2039L127.613 100.033C127.61 100.975 126.943 101.355 126.123 100.882L93.5579 82.0803C92.7376 81.6064 92.0752 80.46 92.0781 79.5179L92.2839 4.3254C92.2868 3.38334 92.9535 3.00217 93.7724 3.4761L126.337 22.2782C127.158 22.7521 127.82 23.8986 127.817 24.8421L127.772 40.8209L127.774 40.8166Z"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <defs>
      <linearGradient
        id="paint0_linear_4444_2061"
        x1="54.0308"
        y1="131.533"
        x2="48.1524"
        y2="141.549"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.29" stopColor="#F5B3A4"></stop>
        <stop offset="0.75" stopColor="#F9D2C8"></stop>
        <stop offset="1" stopColor="#FBDED7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4444_2061"
        x1="152.289"
        y1="176.127"
        x2="151.786"
        y2="104.557"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.51" stopColor="#ED8B7D"></stop>
        <stop offset="1" stopColor="#EB7D74"></stop>
      </linearGradient>
    </defs>
  </svg>
);
